import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { Button } from '../buttons';

type Props = {
  title: string;
  description?: string;
  open?: boolean;
  onClose: (result: boolean) => void;
  onClickConfirm?: () => void;
  onClickCancel?: () => void;
};
const ConfirmationDialog: FC<Props> = ({
  title,
  description,
  open,
  onClose,
  onClickConfirm,
  onClickCancel,
}) => {
  const { t } = useTranslation();

  const handleConfirmClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (onClickConfirm) {
      onClickConfirm();
      onClose(true);
      return;
    }
    onClose(true);
  };

  const handleCancelClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (onClickCancel) {
      onClickCancel();
    }
    onClose(false);
  };

  return (
    <Dialog
      open={open || false}
      onClose={() => onClose(false)}
      style={{ zIndex: 10000 }}
      aria-labelledby={`confirmation-dialog-${title
        .toLowerCase()
        .replace(/[^\w\s]/g, '')
        .replace(/\s/g, '-')}`}
    >
      <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
      {description && (
        <DialogContent>
          <Typography style={{ whiteSpace: 'pre-line' }}>{description}</Typography>
        </DialogContent>
      )}
      <DialogActions>
        <Button variant="text" onClick={handleCancelClick}>
          {t('shared.forms.cancel')}
        </Button>
        <Button autoFocus onClick={handleConfirmClick}>
          {t('shared.forms.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
